(function () {
  function pauseOtherVideos(activeVideo) {
    const allVideos = document.querySelectorAll('video');

    allVideos.forEach(function (video) {
      if (video !== activeVideo) {
        video.pause();
        video.muted = true;
      }
    });
  }

  function bindVideoEvents() {
    const allVideos = document.querySelectorAll('video');

    allVideos.forEach(function (video) {
      if (video.dataset.videoControlBound === 'true') return;

      video.dataset.videoControlBound = 'true';

      video.addEventListener('play', function () {
        video.muted = false;
        video.volume = 1;
        pauseOtherVideos(video);
      });

      video.addEventListener('click', function () {
        pauseOtherVideos(video);
      });
    });
  }

  function observeNewVideos() {
    const observer = new MutationObserver(function () {
      bindVideoEvents();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindVideoEvents();
    observeNewVideos();
  });

  document.addEventListener('shopify:section:load', function () {
    bindVideoEvents();
  });
})();